"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WayPointPopup({
  theme,
  wayPoint: {
    address,
    addressDetail
  }
}) {
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(StyledTitle, null, addressDetail ? addressDetail.primaryText : address), addressDetail && addressDetail.secondaryText && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, addressDetail.secondaryText)));
}
const Wrapper = _styledComponents.styled.div``;
const StyledTitle = (0, _styledComponents.styled)(_Typography2.default)`
  && {
    font-size: 1em;
  }
`;
var _default = exports.default = WayPointPopup;